import React from 'react';

import Proptypes from 'prop-types';

import { FieldInput } from '../../../../../../../form/fields';

const ProductConsoleId = ({ productConsoleId, setProductConsoleId }) => {
  return (
    <div style={{ marginTop: '-2rem' }}>
      <FieldInput
        data={{
          value: productConsoleId,
          placeholder: 'product console order id',
          label: 'Product console order ID',
          onChange: date => {
            setProductConsoleId(date.target.value);
          },
          name: 'iotProductConsoleOrderId',
          required: false,
          readonly: false,
          tooltip: ''
        }}
      />
    </div>
  );
};

ProductConsoleId.propTypes = {
  productConsoleId: Proptypes.string.isRequired,
  setProductConsoleId: Proptypes.func.isRequired
};

export default ProductConsoleId;
